import { Component, input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'lib-ikp-helper-text',
  standalone: true,
  imports: [NgOptimizedImage, TranslatePipe],
  templateUrl: './helper-text.component.html',
})
export class HelperTextComponent {
  helperText = input<string>('');
}
